export default __webpack_public_path__ + "static/media/Quality_Expert.da358bee.png";